





























import Vue from 'vue'
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { PreVendaUseCase } from '@/usecases/venda/PreVendaUseCase'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'

@Component({ components: { SeletorDeUsuario } })
export default class DialogoDeInformarRepresentante extends Vue {
	@PropSync('mostra', { type: Boolean, default: false }) syncMostra!: boolean
	@Prop({ type: String, required: false }) preVendaId!: string
	@Prop({ default: null }) representanteInicial!: any

	carregando = false
	representanteSelecionado: any | null = null

	preVendaUseCase = new PreVendaUseCase()

	get lojaSelecionada() {
		return VendaModule.lojaDaVenda ? [VendaModule.lojaDaVenda.id] : []
	}

	@Watch('syncMostra', { immediate: true })
	onOpen(val: boolean) {
		if (!val) return
		this.representanteSelecionado = this.representanteInicial
	}

	async confirmar() {
		try {
			this.carregando = true

			await this.atualizarSeMudou()

			this.$emit('confirmado', this.representanteSelecionado)
			AlertModule.setSuccess("Representante confirmado na pré venda")
			this.syncMostra = false
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	fechar() {
		this.syncMostra = false
	}

	private async atualizarSeMudou() {
		const idNovo = this.representanteSelecionado?.id ?? null
		const idAntigo = this.representanteInicial?.id ?? null
		if (idNovo === idAntigo) return

		await this.preVendaUseCase.atualizarRepresentante(this.preVendaId, idNovo)
	}

	@Watch('representanteSelecionado')
	async onChange() {
		if (!this.syncMostra) return
		await this.atualizarSeMudou()
	}
}
